import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
    mode: "history",
    routes, // short for routes: routes
    linkActiveClass: 'active',
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    let sesion = (localStorage.getItem('dp-sesion') !== null) ? JSON.parse(localStorage.getItem('dp-sesion')) : { _id: null, token: null, role: null };
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!sesion.token) {
            next('/login')
        } else {
            next()
        }
    } else {
        if (to.path === "/login" && from.path === "/dispatch-panel") {
            if (!sesion.token) {
                next();
            } else {
                next(false);
            }
        } else {
            next()
        }
    }
})

export default router;